import React from "react";
import { Route, Redirect } from "react-router-dom";
import { RouteProps, RouteComponentProps } from "react-router";
import { useCookies } from "react-cookie";
import { connect, ConnectedProps } from "react-redux";
import { ApplicationState } from "../../store";

type Props = RouteProps & {
  component:
    | React.ComponentType<RouteComponentProps<any>>
    | React.ComponentType<any>;
};

export const PrivateRoute: React.FC<Props & PropsFromRedux> = ({
  component: Component,
  ...rest
}) => {
  const [cookies, removeCookie] = useCookies(["tsToken"]);

  const hasToken = React.useCallback(() => {
    if (cookies.tsToken && rest.user?.isValidToken) {
      return true;
    } else {
      removeCookie("tsToken", { path: "/" });
    }
    return false;
  }, [cookies, rest.user?.isValidToken]);

  return (
    <Route
      {...rest}
      render={(props) =>
        hasToken() ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
};

const mapStateToProps = (state: ApplicationState) => ({
  user: state.user?.user,
});

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(PrivateRoute);
